import script from "./UsersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersPage.vue?vue&type=script&setup=true&lang=js"

import "./UsersPage.vue?vue&type=style&index=0&id=4627a409&lang=css"

const __exports__ = script;

export default __exports__